module.exports = __webpack_public_path__ + "img/reference_01.8cc8c7de.jpg";